import Axios from "axios";
import { adminApi } from "../config";

const endpoint = "/users";

export const listAllUsers = async (params: any) => {
  try {
    let url = `${endpoint}`;
    const result = await adminApi.get(url, {
      params,
    });
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const getUserById = async (id: string) => {
  try {
    let url = `${endpoint}/${id}`;
    const result = await adminApi.get(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const createOrLoadMyProfile = async () => {
  try {
    let url = `${endpoint}/me`;
    const result = await adminApi.post(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const updateUser = async (templateId: number, templateData: any) => {
  try {
    let url = `${endpoint}/${templateId}`;
    const result = await adminApi.put(url, templateData);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const deleteUser = async (templateId: string) => {
  try {
    let url = `${endpoint}/${templateId}`;
    const result = await adminApi.delete(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};
